import { useI18NextContext } from '@components/hooks';
import { OfferType, OfferIcons } from '@model/offers/offers';
import { OfferTile } from './OfferTile';
import { useSelector } from 'react-redux';
import { getDestination } from '@state/slices/app';

export interface OfferTileContainerProps {
  offerType: OfferType;
}

export const OfferTileContainer = ({ offerType }: OfferTileContainerProps) => {
  const t: any = useI18NextContext();
  const path = useSelector(getDestination);

  const title = t(`offers__label--${offerType}`);
  const description = t(`offers__description--${offerType}`);

  return (
    <OfferTile icon={OfferIcons[offerType]} title={title} description={description} offerType={offerType} path={path} />
  );
};
